module.exports = __webpack_public_path__ + "static/media/pro_athletics_icon.98dbfe21.svg";